<template>
  <div class="app-dropdown">
    <div class="item" v-for="(item, i) in items" :key="i" @click="setActive(i)">
      <div class="inner">
        <p class="title">
          {{ item.title }}
        </p>
        <img src="/images/icons/cross-ico.svg" alt="" />
      </div>
      <transition name="fade">
        <p v-if="active === i">
          {{ item.description }}
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            title: "Certe inquam pertinax non existimant oportere",
            description: "test description for 1",
          },
          {
            title: "Certe inquam pertinax non possim",
            description: "test description for 2",
          },
          {
            title: "Memoriter tum etiam erga nos",
            description: "test description for 3",
          },
        ];
      },
    },
  },
  data() {
    return {
      active: -1,
    };
  },
  methods: {
    setActive(i) {
      if (this.active === i) {
        return (this.active = -1);
      }
      return (this.active = i);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/Dropdown.vue